import { css } from '@emotion/react';
import canadianFilterBg from '../../../../../assets/canadian-filter-bg.png';

export const filterMenuStyles = {
    root: css({
        display: 'flex',
        flexDirection: 'column',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        zIndex: '100',
        padding: '10px 16px 16px',
        overflowY: 'auto',
        '@media (min-width: 600px)': {
            position: 'absolute',
        },
    }),
    headerWrapper: css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    }),
    header: css({
        margin: 0,
        color: '#000000',
        fontSize: '15px',
        lineHeight: '16px',
        fontWeight: '600',
    }),
    closeIcon: css({
        width: '24px',
        height: '24px',
        cursor: 'pointer',
        visibility: 'visible',
    }),
    reset: css({
        cursor: 'pointer',
        color: '#000',
        fontSize: '15px',
        lineHeight: '16px',
        fontWeight: '500',
        margin: 0,
    }),
    filtersWrapper: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #DAE7FA',
        borderRadius: '8px',
        padding: '8px 15px',
        marginBottom: '10px',
    }),
    filterItemLabel: css({
        fontSize: '15px',
        lineHeight: '15px',
        fontWeight: '700',
        color: '#000000',
    }),
    canadianWrapperActive: css({
        backgroundImage: `url(${canadianFilterBg})`,
    }),
};
